export enum CouncilTenantSwitchStep {
  PropertyLookup,
  Energy,
  Tenant,
  Tcf,
  Consent,
  Summary,
  Confirmation,
}
